
<div>
  <VueFileAgent
     ref="fileAgent"
    :multiple="true"
    :deletable="true"
    :meta="true"
    :accept="acceptExt"
    :maxSize="'2048MB'"
    :maxFiles="maxFiles"
    :helpText="selectText"
    :errorText="{
      type: errorMessage,
      size: errorSize,
    }"
    :thumbnailSize="120"
    :theme="'list'"
     v-model="fileRecords"
     @select="filesSelected($event)"
     @beforedelete="onBeforeDelete($event)"
     @delete="onDelete($event)"
  ></VueFileAgent>
</div>
